import Vue from 'vue';
import UserService from '../service/user.service';
import TenantService from '../service/tenant.service';
import { ROLES } from '../config/roles';

const RolesPlugin = {
  install(/* vue */) {
    Vue.mixin({
      computed: {
        $isLoggedIn() {
          return UserService.loggedIn;
        },
        $userInfo() {
          return UserService.getUserInfo();
        },
        $isAdmin() {
          return this.$hasMatchingRoles([ROLES.ADMIN]);
        },
        $isTenantAdmin() {
          return this.$hasMatchingTenantRoles([ROLES.TENANT_ADMIN]);
        },
        $isTenantBasic() {
          return this.$hasMatchingTenantRoles([ROLES.TENANT_BASIC]);
        },
        $isTenantManager() {
          return this.$hasMatchingTenantRoles([ROLES.TENANT_MANAGER]);
        },
        $isAliurakoitsija() {
          return this.$hasMatchingTenantRoles([ROLES.TENANT_ALIURAKOITSIJA]);
        },
        $isTenantTechAdmin() {
          return this.$hasMatchingTenantRoles([ROLES.TENANT_TECH_ADMIN]);
        },
        $isOnlyTenantBasic() {
          return !this.$hasMatchingTenantRoles([ROLES.TENANT_MANAGER, ROLES.TENANT_ADMIN]) && this.$hasMatchingTenantRoles([ROLES.TENANT_BASIC]);
        },
        $isOnlyTenantAdmin() {
          return !this.$hasMatchingTenantRoles([ROLES.TENANT_MANAGER, ROLES.TENANT_BASIC]) && this.$hasMatchingTenantRoles([ROLES.TENANT_ADMIN]);
        },
        $isOnlyAliurakoitsija() {
          return !this.$hasMatchingTenantRoles([ROLES.TENANT_MANAGER, ROLES.TENANT_ADMIN, ROLES.TENANT_BASIC]) && this.$hasMatchingTenantRoles([ROLES.TENANT_ALIURAKOITSIJA]);
        },
        $isBasicUser() {
          return this.$hasMatchingRoles([ROLES.BASIC]);
        },
        $isAgentUser() {
          return this.$hasMatchingRoles(['agent']);
        },
      },
      methods: {
        $clearUserInfo() {
          UserService.clearUserInfo();
        },
        $hasMatchingRoles(roles) {
          const userInfo = UserService.getUserInfo();
          if (userInfo == null) {
            return false;
          }
          const userRoles = userInfo.roles;
          const matchingRoles = roles.findIndex(role => {
            if (userRoles.length > 0) {
              return userRoles.findIndex(r => r.toLowerCase() === role.toLowerCase()) > -1;
            }
          });
          return matchingRoles > -1;
        },
        $hasMatchingTenantRoles(roles) {
          const userInfo = UserService.getUserInfo();
          if (userInfo == null) {
            return false;
          }

          const savedTenant = TenantService.tenant;

          const tenantIndex = userInfo.tenantRoles.findIndex(tenant => tenant.tenant === savedTenant);
          if (tenantIndex > -1) {
            const userRoles = userInfo.tenantRoles[tenantIndex].roleSet;
            const matchingRoles = roles.findIndex(role => {
              if (userRoles.length > 0) {
                return userRoles.findIndex(r => r.toLowerCase() === role.toLowerCase()) > -1;
              }
            });
            return matchingRoles > -1;
          }
          return false;
        },
      },
    });
  },
};

export default RolesPlugin;
